const TreeNuts = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.3444 5.18691C16.1697 4.93769 15.8303 4.9377 15.6556 5.18692C14.8084 6.39571 13.3879 8.56627 12.181 11.1068C10.97 13.6563 9.99707 16.5308 9.99707 19.1597C9.99707 21.4098 10.4419 23.3807 11.4017 24.7746C12.3424 26.1406 13.8097 27.0014 16 27.0014C18.1903 27.0014 19.6576 26.1406 20.5982 24.7746C21.5581 23.3807 22.0029 21.4098 22.0029 19.1597C22.0029 16.5306 21.03 13.656 19.819 11.1066C18.6121 8.5661 17.1917 6.39564 16.3444 5.18691ZM14.8368 4.61294C15.4096 3.7957 16.5904 3.79568 17.1632 4.61291C18.0286 5.8474 19.4827 8.06825 20.7222 10.6775C21.9575 13.278 23.0029 16.3116 23.0029 19.1597C23.0029 21.5165 22.541 23.7165 21.4218 25.3417C20.2835 26.9948 18.4993 28.0014 16 28.0014C13.5007 28.0014 11.7165 26.9948 10.5781 25.3417C9.45894 23.7165 8.99707 21.5165 8.99707 19.1597C8.99707 16.3119 10.0425 13.2782 11.2778 10.6777C12.5173 8.06843 13.9714 5.84747 14.8368 4.61294Z"
      fill="#2B2B2B"
    />
    <path d="M16 10.796L16 24.796" stroke="black" strokeLinecap="round" />
    <path
      d="M13.5 12.796C13.5 12.796 12 16.296 12 18.796C12 22.296 13 23.796 13 23.796"
      stroke="black"
      strokeLinecap="round"
    />
    <path
      d="M18.5 12.796C18.5 12.796 20 16.296 20 18.796C20 22.296 19 23.796 19 23.796"
      stroke="black"
      strokeLinecap="round"
    />
  </svg>
);

export default TreeNuts;
